import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnterpriseModel } from 'shared';

@Injectable()
export class EnterpriseService {

  private readonly apiUrl = '/api/enterprises';

  constructor(private http: HttpClient) {
  }

  getEnterpriseList(): Observable<EnterpriseModel[]> {
    return this.http.get<EnterpriseModel[]>(`${this.apiUrl}/`);
  }
}
